import { atom, useAtomValue, useSetAtom } from 'jotai';

const accountLinkingTokenAtom = atom<string | null>(null);

export function useAccountLinkingToken() {
  return useAtomValue(accountLinkingTokenAtom);
}

export function useSetAccountLinkingToken() {
  return useSetAtom(accountLinkingTokenAtom);
}
